import { Component } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent {

  goToChildren() {
    window.location.href = environment.link_child;
  }

  goToVirtualMuseum() {
    window.location.href = environment.link_museum;
  }

  goToCollection() {
    window.location.href = environment.link_collection;
  }
}
